module.exports = __webpack_public_path__ + "static/media/ccard-visa.09292c6d.svg";